// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"150":"b8e8fafe","241":"98f5a009","566":"e63ce0fa","596":"0b0217fb","818":"84dcfbbb","965":"40e78358"}[chunkId] + ".css";
};